/**
 * The phone's words for Stage 0's write queue and sync (piece 35, *Write queue
 * and sync (Stage 0)*, *Conflict resolution for queued offline writes (Stage
 * 0)*; decisions 4643, 4652, 4761): the pending clock and its sheet, the
 * offline conflict screen, the update prompt, the removed phone and Sign Out's
 * question while changes wait (T2556), and the words of the six writes queued
 * with no signal (T2475, decision 5220). Spread into
 * the one string lookup beside the earlier batches' words. A word the web
 * already says, Keep Mine, Take Theirs, Your value, Their value and Sign Out, is
 * read from the web's own key and is not repeated here.
 */
export const SYNC_STRINGS = {
  'mobile.sync.clock': 'Changes waiting to sync',
  'mobile.sync.sheet.title': 'Waiting to Sync',
  'mobile.sync.sheet.pending': 'changes wait to be sent.',
  'mobile.sync.sheet.pendingOne': 'change waits to be sent.',
  'mobile.sync.sheet.oldest': 'The oldest was made',
  'mobile.sync.sheet.ago': 'ago.',
  'mobile.sync.sheet.offline': 'The server did not answer the last try. The phone tries again on its own.',
  'mobile.sync.sheet.others': 'changes made by another person on this phone wait for them to sign in.',
  'mobile.sync.sheet.othersOne': 'change made by another person on this phone waits for them to sign in.',
  'mobile.sync.sheet.failed': 'Not saved',
  'mobile.sync.sheet.failedGroup': 'changes that depend on it were not sent either.',
  'mobile.sync.sheet.failedGroupOne': 'change that depends on it was not sent either.',
  'mobile.sync.sheet.noReason': 'The server refused this change.',
  'mobile.sync.noParentId': 'The change this one depends on was saved, but the server did not say which record it made, so this change was not sent.',
  'mobile.sync.unresolvedRef': 'This change names a record that was not saved first, so it was not sent.',
  'mobile.sync.partUnreadable': 'A picture or file this change carries could not be read from the phone, so it was not sent.',
  'mobile.sync.parentFailed': 'The change this one depends on was not saved, so this change is not queued.',
  'mobile.sync.sample.conflict': 'The record changed while this change waited.',
  'mobile.sync.sample.failed': 'The website is not a web address.',
  'mobile.sync.sheet.nothing': 'Every change on this phone has been sent.',
  'mobile.sync.syncNow': 'Sync Now',
  'mobile.sync.retry': 'Retry',
  'mobile.sync.discard': 'Discard',
  'mobile.sync.close': 'Close',
  'mobile.sync.age.now': 'moments',
  'mobile.sync.age.minutes': 'min',
  'mobile.sync.age.hours': 'hr',
  'mobile.sync.age.days': 'days',
  'mobile.sync.conflict.title': 'Changed by someone else while your change waited',
  'mobile.sync.conflict.intro': 'Choose which to keep for the whole change.',
  'mobile.sync.conflict.field': 'Field',
  'mobile.sync.conflict.deleted': 'This record was deleted while your change waited, so it cannot be saved.',
  'mobile.sync.conflict.merged': 'This record was merged into another while your change waited, so it cannot be saved here.',
  'mobile.sync.conflict.dependants': 'later changes that depend on this one follow your choice.',
  'mobile.sync.conflict.dependantsOne': 'later change that depends on this one follows your choice.',
  'mobile.sync.conflict.reading': 'Reading what the server holds now…',
  'mobile.sync.value.none': 'None',
  'mobile.sync.value.yes': 'Yes',
  'mobile.sync.value.no': 'No',
  'mobile.sync.floor.title': 'Update Required',
  'mobile.sync.floor.body': 'This version of the app is older than the server accepts. Your changes stay on this phone until the app is updated.',
  'mobile.sync.floor.build': 'The lowest version the server accepts is build',
  'mobile.sync.floor.later': 'Not Now',
  'mobile.sync.removed.title': 'This Phone Was Removed',
  'mobile.sync.removed.body': 'An administrator removed this phone from your account. It stays removed until it is wiped or allowed again on the web.',
  'mobile.sync.removed.queue': 'changes made on this phone were not sent.',
  'mobile.sync.removed.queueOne': 'change made on this phone was not sent.',
  'mobile.signOut.queued.title': 'Changes Not Sent',
  'mobile.signOut.queued.body': 'Signing out deletes what this phone keeps. These changes have not reached the server, and they would be deleted with it:',
  'mobile.signOut.anyway': 'Sign Out Anyway',
  'mobile.signOut.changes': 'changes',
  'mobile.signOut.newRecord': 'A new record',
  'mobile.store.otherPersonDiscarded': 'Another person’s offline changes on this phone were discarded.',
  // Decision 5220: the six writes queued with no signal, what a screen says of one, and the kinds Waiting to Sync names.
  'mobile.sync.queued': 'Saved on this phone. It is sent when the phone has a signal, and the clock in the header shows it until then.',
  'mobile.sync.waiting': 'Waiting to sync',
  'mobile.sync.sheet.conflict': 'Conflict',
  'mobile.sync.kind.note': 'Note',
  'mobile.sync.kind.checkIn': 'Check In',
  'mobile.sync.kind.checkOut': 'Check Out',
  'mobile.sync.kind.edit': 'Edit',
  'mobile.sync.kind.reportNote': 'Service Report Note',
  'mobile.sync.kind.reportPhotos': 'Service Report Photos',
  'mobile.sync.kind.workOrder': 'Work Order Edit',
  'mobile.sync.kind.expenseLine': 'Expense Line',
  'mobile.sync.kind.file': 'File Upload',
  'mobile.sync.kind.screenshot': 'Screenshot Record',
  'mobile.sync.kind.textReply': 'Text Reply',
  'mobile.sync.kind.other': 'Change',
  // Decision 7771: the two expense writes the phone queues beside + Add Line.
  'mobile.sync.kind.expense': 'Expense',
  'mobile.sync.kind.receiptForReview': 'Receipt for Review',
  // Decision 13030: a time-off request queued with no signal.
  'mobile.sync.kind.timeOff': 'Time Off Request',
} as const;
